export function isTouch () {
    const touchDevice = ('ontouchstart' in document.documentElement);
    const smallScreen = window.matchMedia("only screen and (max-width: 768px)").matches;

    return touchDevice && smallScreen;
};